import { render } from "./router-tabs.vue?vue&type=template&id=6e5fb23c"
import script from "./router-tabs.vue?vue&type=script&lang=js"
export * from "./router-tabs.vue?vue&type=script&lang=js"

import "./router-tabs.vue?vue&type=style&index=0&id=6e5fb23c&lang=scss"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__